var _title, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAnnouncementWhite = function SvgAnnouncementWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/action/all_inbox_24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,1.33333325 C13.1564914,1.33333325 12.9868635,1.40343797 12.8618174,1.5284841 C12.7367713,1.65353023 12.6665658,1.82315813 12.6666667,1.99999992 L12.6666667,2.42448003 C11.5279827,3.83630446 9.81378167,4.6599242 8,4.66666658 L4,4.66666658 C2.89593007,4.66787184 2.00120514,5.56259677 2,6.66666658 L2,7.9999999 C2.00120514,9.10406996 2.89593007,9.9987949 4,9.9999999 L4.32252667,9.9999999 L2.72070667,13.7376 C2.63228257,13.9435248 2.65331846,14.1801094 2.7766877,14.3672025 C2.90005695,14.5542956 3.10922668,14.6668248 3.33333333,14.6666667 L6,14.6666667 C6.26677119,14.6668256 6.50787457,14.507715 6.61263333,14.2623734 L8.42846667,10.0253334 C10.0867485,10.1470867 11.6207813,10.9494346 12.6666667,12.2420467 L12.6666667,12.6666666 C12.6666667,13.0348565 12.9651435,13.3333333 13.3333333,13.3333333 C13.7015231,13.3333333 14,13.0348565 14,12.6666666 L14,1.99999992 C14,1.82315758 13.9298977,1.65352866 13.8048512,1.52848214 C13.6798047,1.40343563 13.5101758,1.33333325 13.3333333,1.33333325 Z M6.98893333,10 L5.56054667,13.3333334 L4.3444,13.3333334 L5.77278667,10 L6.98893333,10 Z M12.6666667,4.3184067 L12.6666667,10.3478667 C11.352172,9.26494703 9.70311287,8.6708499 8,8.66663336 L6,8.66663336 L6,5.9999667 L8,5.9999667 C9.70314513,5.9956135 11.3521942,5.4014046 12.6666667,4.3184067 Z M4.66666667,6.00000003 L4.66666667,8.6666667 L4,8.6666667 C3.63191227,8.6664203 3.33357971,8.36808776 3.33333333,8.00000003 L3.33333333,6.6666667 C3.33358338,6.29858048 3.63191379,6.00025008 4,6.00000003 L4.66666667,6.00000003 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proctored-2-Way-comunication",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-2--way-comm--Announcement",
    transform: "translate(-1151.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(1121.000000, 486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(16.500000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa",
    transform: "translate(12.000000, 12.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0.00133327712,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnnouncementWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/announcementWhite.709f6a28.svg";
export { ForwardRef as ReactComponent };